import './SettingsNav.css'

import { clsx } from 'clsx'
import { type ReactElement, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { ArrowLeft } from '#design-system/icons/arrow-left'
import { SHELL_SETTINGS_NAV_GROUPS } from '~/test-data/shell'

interface SettingsNavProps {
  onBackToApps: () => void
}

export const SettingsNav = ({ onBackToApps }: SettingsNavProps): ReactElement => {
  const { t } = useTranslation()
  const [selectedId, setSelectedId] = useState('apps')

  return (
    <div className="settings-nav">
      <button className="item" onClick={onBackToApps} type="button">
        <ArrowLeft className="icon" />
        <span className="label">{t('shell.nav.back_to_apps')}</span>
      </button>

      <div className="groups">
        {SHELL_SETTINGS_NAV_GROUPS.map((group) => (
          <div key={group.titleKey} className="group">
            <label>{t(group.titleKey)}</label>
            {group.items.map((item) => (
              <button
                key={item.id}
                className={clsx('item', selectedId === item.id && 'selected')}
                onClick={() => {
                  setSelectedId(item.id)
                }}
                type="button"
              >
                {/* Placeholder icon square — matches Figma; real per-item icons are TBD. */}
                <span aria-hidden="true" className="icon-placeholder" />
                <span className="label">{t(item.labelKey)}</span>
              </button>
            ))}
          </div>
        ))}
      </div>
    </div>
  )
}
